//State
export default function(state=null,action){
    switch (action.type) {
      case "COMPLETED_VIEW_DETAILS":
          return action.payload;
      default: return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducer/get_completed_details.js